import { render, staticRenderFns } from "./editWeight.vue?vue&type=template&id=cd4a41e8&scoped=true&"
import script from "./editWeight.vue?vue&type=script&lang=js&"
export * from "./editWeight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd4a41e8",
  null
  
)

export default component.exports